import styled from 'styled-components';

export const GraphicWrapper = styled.div`
  border: 1px solid ${(p) => p.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 24px 32px;
  margin-bottom: 24px;
`;

export const GraphicTitle = styled.div`
  ${(p) => p.theme.typography.subHeader2}
`;
